import React, { useContext, useState, ToastAndroid, useEffect } from "react";
import { getStoreInvoicePrinter, getUserData } from "../../utils/localStorage";
import { useLocation, useNavigate } from "react-router-dom";
import StoreMenu from "../StoreMenu";

import qz from "qz-tray";
import ButtonLink from "../../ButtonLink";
import { getBrandStoreById } from "../../services/StoreUsers/PostStoreUsers";
import AdminMenu from "../AdminMenu";

const RiderChallanComponent = () => {
  const { storeData, brandProfileData, userProfileData, userProfileRole } = getUserData();

  const location = useLocation();
  const { storeId, storeCustomerId, bookingOrderId, customerOrdersData, B2BModel } =
    location.state || {}; // Fallback to prevent undefined errors

  const [adminStoreData, setAdminStoreData] = useState({})

         const fetchStoreUser = () => {
           getBrandStoreById(storeId)
             .then((response) => {
               if (!response.data.error) {
                 const Res = response.data;
                 setAdminStoreData(Res);
               }
             })
             .catch((err) => {
               console.error("Error:", err);
             });
         };
    
         useEffect(() => {
          fetchStoreUser();
         }, [])

  let store = userProfileRole === "BY_STORE" ? storeData : adminStoreData;
  let brand = brandProfileData;
  const userProfile = userProfileData;

  

  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();
  const data = {
    storeName: store?.storeName,
    brandName: brand?.name,
    fullAddress: store?.address?.fullAddress,
    mobileNumber: store?.mobileNo,
    email: store?.email,
    orderNo: customerOrdersData?.orderNo,
    billNo: customerOrdersData?.invoiceNo,
    date: customerOrdersData?.createdDate?.split("T")[0],
    customerName: customerOrdersData?.customerName,
    customerMobile: customerOrdersData?.customerMobile,
    customerAddress: customerOrdersData?.customerAddress,
    deliveryDate: customerOrdersData?.deliveryOn?.split("T")[0],
    grandTotal: customerOrdersData?.grandTotal,
    gstAmount: customerOrdersData?.gstAmount,
    totalAmount: customerOrdersData?.totalAmount,
    discountAmount: customerOrdersData?.discountAmount,
    chargeAmount: customerOrdersData?.chargeAmount,
    offerDiscount: customerOrdersData?.offerDiscount,
    taxableAmount: customerOrdersData?.taxableAmount,
    gstPercent: customerOrdersData?.gstPercent,
    remarks: customerOrdersData?.remarks,
    itemGarmentCount: customerOrdersData?.itemGarmentCount,
    garmentQrCount: customerOrdersData?.garmentQrCount,
    orderItems: customerOrdersData?.orderItem.map((item) => ({
      ...item,
      addOns: item.addOns || [], // Ensure addOn is always an array
    })),
  };

  const  orderItems = customerOrdersData?.orderItem.map((item) => ({
    ...item,
    addOns: item.addOns || [], // Ensure addOn is always an array
  }))

  const totalGarmentQrCount = customerOrdersData?.orderItem.reduce(
    (sum, item) => {
      return sum + (item.garmentQrCount || 0); // add garmentQrCount or 0 if undefined
    },
    0
  );

  const [isConnected, setIsConnected] = useState(false);

  const connectToQZ = async () => {
    try {
      if (!qz.websocket.isActive()) {
        await qz.websocket.connect();
        setIsConnected(true);
      }
    } catch (err) {
      console.error("Connection error:", err);
    }
  };

  const [invoicePrinterValue, setInvoicePrinterValue] = useState("");
  const fetchSelectedInvoicePrinter = async () => {
    try {
      const selectedInvoicePrinterData = await getStoreInvoicePrinter();
      setInvoicePrinterValue(selectedInvoicePrinterData?.invoicePrinter || "");
    } catch {
      setInvoicePrinterValue("");
    }
  };

  useEffect(() => {
    if(!isConnected) 
      {
        connectToQZ();
      }

    fetchSelectedInvoicePrinter()
  }, [])
  
  const printInvoiceHTML = async () => {
    try {
      // const printer = await qz.printers.find("POS80 Printer"); // Adjust to your printer's actual name
      const printer = await qz.printers.find(invoicePrinterValue);
      const config = qz.configs.create(printer, {
        encoding: "UTF-8",
        size: { width: 3 },
        units: "in",
        density: "600",
        colorType: "grayscale",
      });

      const orderItemsHtml = data.orderItems
        .map((item) => {
          const name = item.garmentAlias.replace(/_/g, " ") || item.garmentName.replace(/_/g, " ");

          // Convert service names to a string with <br> line breaks
          const service = item.addOns
            .map((addOnItem) => addOnItem.serviceName)
            .join("<br>");

          const qty = 
          item.bookingType === "PackageBooking" ? ' - ' :
          item.addOns
            .map(
              (addOn) =>
                `${addOn.count + addOn.countGram}${
                  addOn.serviceUnit === "Qty" ? " Pcs" : addOn.serviceUnit
                }`
            )
            .join("<br>");

          const ic = item.itemGarmentCount;

          return `
      <div style="display: flex;">
        <p style="flex: 2; font-size: 12px; margin: 0; text-align: left;">${name}</p>
        <p style="flex: 2; font-size: 12px; margin: 0; text-align: left;">${service}</p>
        <p style="flex: 1; font-size: 12px; margin: 0; text-align: right;">${qty}</p>
        <p style="flex: 1; font-size: 12px; margin: 0; text-align: right;">${ic}</p>
      </div>
    `;
        })
        .join("");

      const htmlContent = `
      <html>
        <body style="font-size: 12px; font-family: sans-serif;">
          <div style="text-align: center;">
            <span style="font-size: 18px; font-weight: bold;">Challan</span>
            <hr style="border-top: 1px dashed #000;"/>
            <p style="font-size: 14px; font-weight: bold; margin: 0;">${data.storeName}</p>
            <p style="font-size: 12px; margin: 0;">${data.fullAddress}</p>
            <p style="font-size: 12px; margin: 0;">${data.mobileNumber}</p>
            <p style="font-size: 12px; margin: 0;">${data.email}</p>
            <hr style="border-top: 1px dashed #000;"/>
            <div style="display: flex; justify-content: space-between;">
               <span><strong>Order No.:</strong></span>
              <span>${data.orderNo}</span>
            </div>
            <div style="display: flex; justify-content: space-between;">
               <span><strong>Bill No.:</strong></span>
              <span>${data.billNo}</span>
            </div>
            <hr style="border-top: 1px dashed #000;"/>
            <div style="display: flex; justify-content: space-between;">
              <span><strong>Date:</strong></span>
              <span>${data.date}</span>
            </div>
            <hr style="border-top: 1px dashed #000;"/>
            <p style="font-size: 14px; font-weight: bold; margin: 0;">${data.customerName}</p>
            <p style="font-size: 12px; margin: 0;">${data.customerAddress}</p>
            <p style="font-size: 12px; margin: 0;">${data.customerMobile}</p>
            <hr style="border-top: 1px dashed #000;"/>
            <div style="display: flex;">
              <p style="flex: 2; font-weight: bold; margin: 0; text-align: left;">Name</p>
              <p style="flex: 2; font-weight: bold; margin: 0; text-align: left;">Service</p>
              <p style="flex: 1; font-weight: bold; margin: 0; text-align: right;">Qty</p>
              <p style="flex: 1; font-weight: bold; margin: 0; text-align: right;">IC</p>
            </div>
            ${orderItemsHtml}
              <div style="display: flex; justify-content: space-between;">
              <span><strong>Total Garments:</strong></span>
              <span><strong>${data.itemGarmentCount}</strong></span>
            </div>
            <div style="display: flex; justify-content: space-between;">
              <span><strong>Delivery Date:</strong></span>
              <span>${data.deliveryDate}</span>
            </div>
            <hr style="border-top: 1px dashed #000;"/>
            <p style="font-size: 16px; font-weight: bold;">Powered By ${data.brandName}</p>
          </div>
        </body>
      </html>
    `;

      await qz.print(config, [
        { type: "html", format: "plain", data: htmlContent },
      ]);
      // alert("HTML challan sent to printer!");
    } catch (err) {
      console.error("Print failed:", err);
      alert("Failed to print challan");
    }
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => {
                    if (B2BModel) {
                      navigate("/B2BOrdersGarmentInfo", {
                        state: {
                          storeCustomerId: storeCustomerId,
                          bookingOrderId: bookingOrderId,
                        },
                      });
                    } else if (
                      userProfileRole === "BY_ADMIN" ||
                      userProfileRole === "BY_SUB_ADMIN_USER"
                    ) {
                      navigate("/OrdersGarmentInfo", {
                        state: {
                          storeIdValue: storeId,
                          bookingOrderId: bookingOrderId,
                          storeCustomerId: storeCustomerId,
                        },
                      });
                    } else {
                      navigate("/OrdersGarmentInfo", {
                        state: {
                          storeCustomerId: storeCustomerId,
                          bookingOrderId: bookingOrderId,
                        },
                      });
                    }
                  }}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                Order Challan
              </p>
            </div>
            <div className="flex">
              <div
                className="mx-4 cursor-pointer"
                onClick={printInvoiceHTML}
              >
                <img
                  src={"images/printer.png"}
                  style={{
                    width: 35,
                  }}
                />
              </div>
            </div>
          </div>
          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="flex justify-content-between mt-2">
        <div></div>
        <div className="w-5 ">
          <div className="flex justify-content-center flex-column print-section">
            <p className="text-2xl font-medium text-center line-height-2">
              Challan
            </p>
            <div className="flex justify-content-center align-items-center">
              <p className="w-7  border-dashed border-1  "></p>
            </div>
            <p className="text-lg font-medium text-center line-height-2">
              {data.storeName}
            </p>
            <p className="text-md font-normal text-center line-height-2">
              {data.fullAddress}
            </p>
            <p className="text-md font-normal text-center line-height-2">
              {data.mobileNumber}
            </p>
            <p className="text-md font-normal text-center line-height-2">
              {data.email}
            </p>
            <div className="flex justify-content-center align-items-center">
              <p className="w-5  border-dashed border-1 "></p>
            </div>
            <div className="flex justify-content-center gap-1">
              <p className="text-md font-medium text-left line-height-2">
                Order No.:
              </p>
              <p className="text-md font-medium text-right line-height-2">
                {data.orderNo}
              </p>
            </div>
            <div className="flex justify-content-center gap-1">
              <p className="text-md font-medium text-left line-height-2">
                Bill No.:
              </p>
              <p className="text-md font-medium text-right line-height-2">
                {data.billNo}
              </p>
            </div>
            <div className="flex justify-content-center align-items-center">
              <p className="w-5  border-dashed border-1  "></p>
            </div>
            <div className="flex justify-content-between gap-5">
              <p className="text-md font-medium text-left line-height-2">
                Date:
              </p>
              <p className="text-md font-normal text-right line-height-2">
                {data.date}
              </p>
            </div>
            <div className="flex justify-content-center align-items-center">
              <p className="w-5  border-dashed border-1  "></p>
            </div>
            <p className="text-md font-medium text-center line-height-2">
              {data.customerName}
            </p>
            <p className="text-md font-medium text-center line-height-2">
              {data.customerAddress}
            </p>
            <p className="text-md font-medium text-center line-height-2">
              {data.customerMobile}
            </p>
            <div className="flex justify-content-center align-items-center">
              <p className="w-5  border-dashed border-1  "></p>
            </div>
            <div className="flex">
              <p
                className="text-md font-medium text-left line-height-1"
                style={{ flex: 2 }}
              >
                Name:
              </p>
              <p
                className="text-md font-medium text-left line-height-1"
                style={{ flex: 2 }}
              >
                Service
              </p>
              <p className="flex-1 text-md font-medium text-right line-height-1">
                Qty
              </p>
              <p className="flex-1 text-md font-medium text-right line-height-1">
                IC
              </p>
            </div>
            {data.orderItems.map((item) => (
              <div className="flex " key={item.id}>
                <p
                  className="text-md font-normal text-left line-height-1"
                  style={{ flex: 2 }}
                >
                  {item.garmentAlias !== ""
                    ? item.garmentAlias.replace(/_/g, " ")
                    : item.garmentName.replace(/_/g, " ")}
                </p>
                <p
                  className="text-md font-normal text-left line-height-1"
                  style={{ flex: 2 }}
                >
                  {item.addOns.map((addOnItem, i) => (
                    <p
                      key={i}
                      className="text-md text-left line-height-1 font-normal"
                    >
                      {addOnItem.serviceName}
                    </p>
                  ))}
                </p>

                <p className="flex-1 text-md font-normal text-left line-height-1">
                  {item.bookingType === "PackageBooking" ?  <p
                      className="text-md text-right line-height-1 font-normal"
                    > - </p>:
                    item.addOns.map((addOnItem, i) => (
                    <p
                      key={i}
                      className="text-md text-right line-height-1 font-normal"
                    >
                      {addOnItem.count + addOnItem.countGram}{" "}
                      {addOnItem.serviceUnit === "Qty"
                        ? " Pcs"
                        : addOnItem.serviceUnit}
                    </p>
                  ))}
                </p>
                <p className="flex-1 text-md font-normal text-right line-height-1">
                  {item.itemGarmentCount}
                </p>
              </div>
            ))}

            <div className="flex ">
              <p
                className="text-md font-medium text-left line-height-2"
                style={{ flex: 2 }}
              >
                Total Garments :
              </p>
              <p
                className="text-md font-medium text-left line-height-2"
                style={{ flex: 2 }}
              ></p>
              {/* <p className="text-md font-medium text-right" style={{ flex: 1 }}>
                {totalGarmentQrCount}
              </p> */}
              <p
                className="text-md font-medium text-right line-height-2"
                style={{ flex: 1 }}
              >
                {data.itemGarmentCount}
              </p>
            </div>
            <div className="flex justify-content-between gap-5">
              <p className="text-md font-medium text-left line-height-2">
                Delivery Date:
              </p>
              <p className="text-md font-medium text-right line-height-2">
                {data.deliveryDate}
              </p>
            </div>

            <div className="flex justify-content-center align-items-center">
              <p className="w-7  border-dashed border-1 "></p>
            </div>
            <p className="text-3xl font-medium text-center">
              Powered By {data.brandName}
            </p>
          </div>
        </div>

        <div className="ml-4 cursor-pointer" onClick={() => window.print()}>
          <img
            src={"Icons/printer.png"}
            style={{
              width: 65,
            }}
          />
        </div>
      </div>
      {/* Menu component */}

      {(userProfileRole === "BY_STORE") ? 
        <StoreMenu setVisible={setVisible} visible={visible} />
        :
        <AdminMenu setVisible={setVisible} visible={visible} />
      }
      <ButtonLink />
      <style>
        {`
          @media print {
            body * {
              visibility: hidden;
            }
            .print-section, .print-section * {
              visibility: visible;
            }
            .print-section {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              page-break-after: always;
            }
              @page {
              size: 80mm auto;
              margin: 2mm;
            }
          }
        `}
      </style>
    </div>
  );
};

export default RiderChallanComponent;
